import React from "react";
import { useIntl } from "react-intl";

import IncotermItem from "../../app/generic/incotermItem";
import ServiceWithParameter from "./serviceWithParameter";

const Incoterms = ({
  disabled,
  productCode,
  formItemLayout,
  initialServices,
  getFieldDecorator,
}) => {
  const intl = useIntl();
  return (
    <ServiceWithParameter
      label={intl.formatMessage({
        id: "consignment.services.incoterms",
        defaultMessage: "Parita",
      })}
    >
      <IncotermItem
        label="&nbsp;"
        disabled={disabled}
        productCode={productCode}
        formItemLayout={formItemLayout}
        initialServices={initialServices}
        getFieldDecorator={getFieldDecorator}
      />
    </ServiceWithParameter>
  );
};

export default Incoterms;
